module.exports = __webpack_public_path__ + "static/media/templatethree33.761c67cc.png";